import { type ConfigProviderProps, Empty, type GetProp } from 'antd'

export const renderEmpty: GetProp<ConfigProviderProps, 'renderEmpty'> = _componentName => {
  return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Keine Daten vorhanden" />
}
